import {
  CourseEntityInput,
  CourseEvaluation,
} from "../../../services/courses/courses.types";

// What the Evaluaciones tab edits: the chosen program and trimester plus the
// questions preloaded from them, one per course.
export interface TrimesterEvaluationState {
  programId?: number;
  trimester?: number;
  questions: CourseEvaluation[];
}

export const emptyTrimesterEvaluation: TrimesterEvaluationState = {
  questions: [],
};

// A question stands for a course: its title is what the teacher sees and what
// is stored as the question's key_learnings.
export const evaluationQuestionTitle = (question: CourseEvaluation) =>
  question.related_course?.title ??
  question.key_learnings ??
  `Curso ${question.related_course_id}`;

// The backend rejects anything but an integer of at least 1.
export const isValidQuestionPoints = (
  points?: number | null,
): points is number => Number.isInteger(points) && (points as number) >= 1;

export const initialValuesCourse: CourseEntityInput = {
  title: "",
  clave: "",
  content: "",
  pda: "",
  learning_goals: "",
  book_linking_nem: "",
  ability: "",
  stroke_goals: "",
  syllabic_phonetic_goals: "",
  communication_goals: "",
  structures: "",
  student_structures: "",
  vocabulary_new_words: "",
  vocabulary_review_words: "",
  phonemics_reading_goals: "",
  key_learnings: "",
  rubric_achieved: "",
  rubric_in_process: "",
  rubric_needs_support: "",
  axis: "",
  diagnostic: false,
  subject_id: 1,
  lessons: [],
  tags: [],
  courseEvaluations: [],
  // Valores para proyectos
  trigger_question: "",
  final_product: "",
  summary: "",
  human_to_community: "",
  ejes_articuladores: [],
  habilidades_siglo_xxi: [],
  weeks: "",
  trimester: 1,
  course_ids: [],
  program_ids: [],
};
